<router-outlet></router-outlet>
<app-hr-tool-compare-bar />
